export default "__VITE_ASSET__4d775e55__"